import { get } from './client';
import { buildPath, toJson } from './utils';
import { ADMIN_ORGANIZATIONS_AUTOCOMPLETE_PATH, ADMIN_ORGANIZATIONS_PARENT_AUTOCOMPLETE_PATH } from './constants';
import { AdminOrganizationAutoCompleteType } from './types';

export const getOrganizationAutoComplete = (options: any): Promise<AdminOrganizationAutoCompleteType> =>
  get(buildPath(ADMIN_ORGANIZATIONS_AUTOCOMPLETE_PATH), options).then(toJson);

export const getOrganizationParentAutoComplete = (options: any): Promise<AdminOrganizationAutoCompleteType> =>
  get(buildPath(ADMIN_ORGANIZATIONS_PARENT_AUTOCOMPLETE_PATH), options).then(toJson);
